import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const FileShareStyles = css`
  padding: 0.5em 0em;
  background-color: ${theme.colors.blues[5]};
  border-radius: ${theme.borderRadius[1]};
  cursor: pointer;
  span {
    font-weight: ${theme.fontWeights.semibold};
  }
`;

export const UploadLabel = css`
  display: inline-block;
  font-size: ${theme.fontSizes[2]};
  color: ${theme.colors.blues[100]};
  cursor: pointer;
`;
